import { MoveDown, MoveUp } from "lucide-react"
import { Button } from "../ui/button"

interface AdjustableButtonProps extends React.CustomComponentPropsWithRef<
  typeof Button
> {
  onClick: () => void
  disabled: boolean
  "aria-label": string
}
export function AdjustableRanking({
  increaseButtonProps,
  decreaseButtonProps,
}: {
  increaseButtonProps: AdjustableButtonProps
  decreaseButtonProps: AdjustableButtonProps
}) {
  return (
    <div>
      <Button variant={"ghost"} size={"icon"} {...increaseButtonProps}>
        <MoveUp />
      </Button>
      <Button variant={"ghost"} size={"icon"} {...decreaseButtonProps}>
        <MoveDown />
      </Button>
    </div>
  )
}
